function Footer() {
  return (
    <div className="footer">
      <div className="footer__left">
        <div className="footer__logo-box ">
          <img src="/astro.png" alt="Astro logo" className="footer__logo" />
          <p className="footer__logo-text">Content Distribution</p>
        </div>
        {/* <p className="footer__address">
          Copyright © 2024 <br /> All Asia Broadcast Center, Technology Park
          Malaysia, Bukit Jalil, 57000 Kuala Lumpur
        </p> */}
        <div className="footer__contact">
          <p className="footer__contact-text">
            <a
              href="https://acm-cms-assets.eco.astro.com.my/acm/media/astro-biz/astro_privacy-notice_business-partners_2024.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__terms"
            >
              Terms & Conditions
            </a>
          </p>
        </div>
      </div>
      <div className="footer__right">
        {/* <div className="footer__newsletter">
          <p className="footer__newsletter-title">
            
          </p>
        </div> */}
        <p className="footer__address">
          Copyright © 2026 <br /> All Asia Broadcast Center, Technology Park
          Malaysia, Bukit Jalil, 57000 Kuala Lumpur
        </p>
        <div className="footer__contact">
          <p className="footer__contact-text">
            For more informations please contact <br />
            Astro Content Sales : <strong>content_sales@astro.com.my</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
